import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

export function usePageParams() {
  return usePageParamsFromSchema(getPaginationSchema());
}

type PageParams = ReturnType<typeof usePageParams>;
